












import {
  ref,
  defineComponent,
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'BlikCode',
  setup() {
    const code = ref('');
    return {
      code,
    };
  },
});
